var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Box, Icon, TextBody } from '@ally/metronome-ui';
import { muiInfoFill } from '@ally/metronome-icons';
export var ErrorBanner = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement(Box, __assign({ display: "flex", alignItems: "center", mb: "md", "data-allytm-error": children }, rest),
        React.createElement(Box, { flexShrink: 0 },
            React.createElement(Icon, { icon: muiInfoFill, fill: "error", mr: "xs", size: "lg" })),
        React.createElement(TextBody, { size: "sm", tag: "p", focusOnMount: true }, children)));
};
//# sourceMappingURL=ErrorBanner.js.map